export const METRE_TO_NAUTICAL_MILE_FACTOR = 0.000539957;

export const METRE_PER_SECOND_TO_KNOT_FACTOR = 1.94384;
